/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Globals from "../shared/Globals";
import { qreq } from "../shared/qrequest";
import Address from "./Address";
import Alert from "./Alert";
import AppFormActions from "./AppFormActions";
import BaseCom from "./BaseCom";
import Card from "./Card";
import FormInput from "./FormInput";
import Icon from "./Icon";
import L from "./Lang";
import LoadingAlert from "./LoadingAlert";
import { NavMenuGlobal } from "./NavMenu";
import Shipping from "./Shipping";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";

class Customer extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            info: {},
            shippings: [],
            existing: false,
            new: true,
            searchCust: true
        };
        this.load = this.load.bind(this);
        this.selectCustomer = this.selectCustomer.bind(this);
        this.newCustomer = this.newCustomer.bind(this);
        this.submit = this.submit.bind(this);
    }

    async componentDidMount() {
        NavMenuGlobal.setPath('Customer;' + (this.props.params.id ? 'Edit' : 'New'));
        await this.fillListAsync('/api/customer/group/list', 'groupList');
        await this.fillListAsync('/api/customer/sa/list', 'saList');
        await this.fillListAsync('/api/customer/term/list', 'termList');
        this.load();
    }

    componentWillUnmount() {
        NavMenuGlobal.clearTitle();
    }

    load() {
        if (this.props.params.id) {
            qreq.get('/api/customer/item?id=' + this.props.params.id, j => {
                if (j.item) {
                    if(j.item.shippings) {
                        let idx = 0;
                        j.item.shippings.forEach(i => {
                            if(!i.tax)
                                i.tax = {};
                            if(!i.tax.tax_expired)
                                i.tax.tax_expired = Globals.toISODateString(new Date());
                            try {
                                let d = Date.parse(i.tax.tax_expired);
                                if(d < new Date('2000-01-01'))
                                    i.tax.tax_expired = Globals.toISODateString(new Date());
                            }
                            catch{}
                            i.idx = idx++;
                        });
                    }
                    this.setState({ info: j.item, new: false, searchCust: false, existing: true, canEdit: j.item.isEditable });
                    this.setState({ shippings: j.item.shippings });
                }
                else
                    this.alert(j.errorMessage);
            }, this.unkownErrorCallback);
        }
    }


    selectCustomer(v) {
        if (v)
            this.fillItem('/api/customer/item?id=' + v.id, 'info');
        else
            this.setState({ info: {} });
        this.setState({ new: v ? false : true, searchCust: v ? false : true })
    }

    newCustomer(v) {
        this.setState({ new: true, searchCust: false, canEdit: true, info: { cust_name: v, customerID: null } })
    }
    
    submit(e) {
        e?.preventDefault();
        this.setState({ submitting: true });
        qreq.post('/api/customer/save', {...this.state.info, shippings: this.state.shippings }, j => {
            if(j.errorCode)
                this.alert(j.errorMessage);
            else {
                this.success('Customer saved successfully!');
                this.goBack();
            }
            this.setState({ submitting: false });
        }, () => {
            this.alert(<L>Unknown Error: It is possble that a input value is longer than the allowed value.</L>);
            this.setState({ submitting: false });
        });
    }

    addShipping = () => {
        let idx = this.state.shippings.length + 1;
        this.pushList('shippings', { idx: idx, ship_num: String(idx), tax: {} })
    }

    removeShipping = (ship) => {
        let shippings = this.state.shippings;
        let i = shippings.indexOf(ship);
        shippings.splice(i, 1);
        this.setState({ shippings: shippings, info: {...this.state.info, shippings: shippings} });
    }
    
    change = () => {
        this.setState({ info: {...this.state.info}, shippings: [...this.state.shippings] });
    }

    shippingChange = (ship) => {
        let shippings = [...this.state.shippings];
        let i = shippings.findIndex(a => a.ship_num === ship.ship_num);
        shippings[i] = ship;
        this.setState({ shippings: shippings, info: {...this.state.info, shippings: shippings} });
    }

    render() {
        return <div className="container-fluid">
            <form onSubmit={this.submit}>
                <div className="row">
                    <div className="col-md">
                        <Card title="Customer">
                            {this.state.existing ? <input type="text" value={this.state.info?.cust_name} disabled className="form-control" /> : 
                                <div><FormInput model={this.state.info} name="cust_name" label="Customer Name" type="text" labelAsPlaceholder onChange={v => this.setState({ searchCust: v ? false : true, new: v ? true : false, canEdit: v ? true : false })} transformUpperCase required maxLength={40} /></div>}
                        </Card>
                        <Address item={this.state.info} labelAsPlaceholder disabled={!this.state.canEdit} />
                        <Card title="Contact Info">
                            <FormInput model={this.state.info} name="phone" label="Phone" type="text" labelAsPlaceholder disabled={!this.state.canEdit} maxLength={20} required />
                            <FormInput model={this.state.info} name="fax" label="Fax" type="text" labelAsPlaceholder disabled={!this.state.canEdit} maxLength={20} />
                            <FormInput model={this.state.info} name="email" label="Email" type="email" labelAsPlaceholder disabled={!this.state.canEdit} maxLength={40} />
                        </Card>
                    </div>
                    <div className="col-md">
                        <Card title="Group">
                            {this.state.groupList ? <FormInput model={this.state.info} name="cust_group" label="Group" type="select" keyName="cust_group" options={this.state.groupList} labelAsPlaceholder disabled={!this.state.canEdit} required /> : <LoadingAlert />}
                            {this.state.saList ? <FormInput model={this.state.info} name="sa_cust" label="S/A" type="select" keyName="sa_cust" options={this.state.saList} labelAsPlaceholder disabled={!this.state.canEdit} required /> : <LoadingAlert />}
                        </Card>
                    </div>
                </div>
                {this.state.shippings.map((i,idx) => <Shipping key={idx} idx={idx} item={i} customer={this.state.info} onRemove={this.removeShipping} disabled={!this.state.canEdit} onChange={this.shippingChange} />)}
                {this.state.canEdit && <div className="m-3 text-end">
                    <button type="button" className="btn btn-secondary btn-lg" onClick={this.addShipping} disabled={!this.state.canEdit}><Icon icon="faShip" /> Add Shipping Location</button>
                </div>}
                <AppFormActions showBackButton>
                    {this.state.canEdit && <div className="flex-fill text-end">
                        <button type="submit" className="btn btn-primary btn-lg" disabled={this.state.submitting}><Icon icon="faSave" /> <L>Save</L></button>
                    </div>}
                </AppFormActions>
            </form>
        </div>;
    }
}

export default withParamsAndNavigate(Customer);